import "./style.css";
import React from "react";
import App from './App';
import { createRoot } from "react-dom/client"

createRoot(document.querySelector("#root")).render(
  <App/>
);